import { outter_post } from 'common/js/axios-helper';
const host = "8885";
// 用户列表
const listMerH = (data) => {
  return outter_post('/merchantUserSh/listMerH', data, host);
};

// 后台查询绑定列表列表
const listMerchantUserShH = (data) => {
  return outter_post('/merchantUserSh/listMerchantUserShH', data, host);
};
// 后台查询收益
const listWalletH = (data) => {
  return outter_post('/merchantUserSh/listWalletH', data, host);
};
// 后台查询提现列表
const listTx = (data) => {
  return outter_post('/merchantUserSh/listTx', data, host);
};

export default {
  listMerH,
  listMerchantUserShH,
  listWalletH,
  listTx
}


// WEBPACK FOOTER //
// ./src/service/MerchantManage.js